import TagManager from 'react-gtm-module'

export default {
    dataLayer: function (eventDetail) {
        const { event, ...rest } = eventDetail;
        TagManager.dataLayer({ dataLayer: {event, ...rest}});
    }
}
